import { getPcekZone } from '@entities/user'
import { ConfirmationType } from '@entities/payment'
import { ewalletReqHeaders } from '@shared/config/constants'
import { formatDate } from '@shared/lib/date'
import { generateUuid } from '@shared/lib'
import { TransactionResponse } from '@root/api/ump-ewallet'
import { ewalletApi } from '@root/api/api'
import FormUtils from '../lib/FormUtils'

const BROWSER_ACCEPT_HEADER = '*/*'
const DEFAULT_COLOR_DEPTH = 1
const colorDepthPossibleValues = [1, 4, 8, 15, 16, 24, 32, 48]
const getColorDepth = (value: number, defaultValue: number = DEFAULT_COLOR_DEPTH) =>
  colorDepthPossibleValues.reduce((result, item) => (item <= value ? item : result), defaultValue)
const submitForm = (formElement: HTMLFormElement) => {
  if (typeof formElement.requestSubmit === 'function') {
    formElement.requestSubmit()
  } else {
    formElement.submit()
  }
}

interface ThreeDs2PcekAcsRq {
  url: string
  creq: string
}

interface ThreeDs2PcekAuthProps {
  mdOrder: string
  callbackUrl: string
  url: string
  threeDsMethodUrl?: string
  threeDsMethodData?: string
}

class ThreeDs2PcekAuth {
  public static call(acsRequest: ThreeDs2PcekAuthProps): Promise<TransactionResponse> {
    const zone = getPcekZone()
    const { colorDepth, width, height } = window.screen
    const { userAgent, language } = navigator

    let FhpSessionId
    let FhpRequestId

    if (typeof window !== 'undefined') {
      FhpSessionId = window?.gibSessionId
      FhpRequestId = window?.gibRequestId
    }

    return new Promise<TransactionResponse>((resolve, reject) => {
      if (acsRequest?.threeDsMethodUrl) {
        const iframeName = 'threeDsForm'
        const iframe = document.createElement('iframe')

        iframe.setAttribute('name', iframeName)
        iframe.setAttribute('style', 'width:0; height:0; opacity:0, visibility:hidden')
        iframe.setAttribute('sandbox', 'allow-forms allow-scripts allow-same-origin')

        document.body.append(iframe)

        const formElement = FormUtils.createForm(acsRequest.threeDsMethodUrl)

        formElement.setAttribute('target', iframeName)
        formElement.appendChild(FormUtils.createField('threeDSMethodData', acsRequest.threeDsMethodData as string))
        // formElement.appendChild(FormUtils.createField('MD', acsRequest.mdOrder))

        document.body.append(formElement)
        submitForm(formElement)
      }

      // eslint-disable-next-line no-underscore-dangle
      ewalletApi
        ._3ds2proceed(
          zone,
          acsRequest.mdOrder,
          {
            threeDsRequestorUrl: acsRequest.threeDsMethodUrl,
            browserJavaEnabled: typeof navigator.javaEnabled === 'function' && navigator.javaEnabled(),
            browserLanguage: language,
            browserColorDepth: getColorDepth(colorDepth),
            browserScreenHeight: height,
            browserScreenWidth: width,
            browserTZ: parseInt(formatDate(new Date(), '%Z'), 10),
            browserUserAgent: userAgent,
            notificationUrl: acsRequest.callbackUrl,
            browserAcceptHeader: BROWSER_ACCEPT_HEADER,
            mdOrder: acsRequest.mdOrder,
          },
          {
            headers: { ...ewalletReqHeaders, FhpSessionId, FhpRequestId, 'X-Request-Id': generateUuid() },
          }
        )
        .then((response) => {
          if (
            // challenge flow
            response?.data?.acsUrl &&
            response?.data?.cReq &&
            response?.data?.confirmationType === ConfirmationType.FINISH_3DS2
          ) {
            this.acsCall({
              url: response.data.acsUrl,
              creq: response.data.cReq,
            })
          } else {
            resolve(response.data)
          }
        })
        .catch((error) => reject(error))
    })
  }

  static acsCall(acsRequest: ThreeDs2PcekAcsRq) {
    const formElement = FormUtils.createForm(acsRequest.url)

    formElement.appendChild(FormUtils.createField('creq', acsRequest.creq))

    document.body.append(formElement)
    submitForm(formElement)
  }
}

export { ThreeDs2PcekAuth }
